import { Action } from 'redux';

import { SiteCountAndCloudAdminStatusAction, SiteCountAndCloudAdminStatusActionSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ISiteCountAndCloudAdminStatus } from '../serverApi/types/ISiteCountAndCloudAdminStatus';


export interface SiteCountAndCloudAdminStatusAction extends Action {}
export function siteCountAndCloudAdminStatusRequest(): SiteCountAndCloudAdminStatusAction {
  return {
    type: SiteCountAndCloudAdminStatusAction
  };
}

export const isSiteCountAndCloudAdminStatusAction = isActionFactory<SiteCountAndCloudAdminStatusAction>(SiteCountAndCloudAdminStatusAction);



export interface SiteCountAndCloudAdminStatusSucceededAction extends Action {
  readonly siteInfo: ISiteCountAndCloudAdminStatus;
}

export function siteCountAndCloudAdminStatusSucceeded(siteInfo: ISiteCountAndCloudAdminStatus): SiteCountAndCloudAdminStatusSucceededAction {
  return {
    type: SiteCountAndCloudAdminStatusActionSucceeded,
    siteInfo
  };
}

export const isSiteCountAndCloudAdminStatusSucceededAction = isActionFactory<SiteCountAndCloudAdminStatusSucceededAction>(SiteCountAndCloudAdminStatusActionSucceeded);